import PropTypes from "prop-types";
import {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, makeStyles, Typography} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import CategoryList from "./CategoryList";
import TemplatesGrid from "./TemplatesGrid";
import CreateFromTemplate from "./CreateFromTemplate";
import request from "../../../../../../../../Services/API/Requests";

const useStyles = makeStyles(() => ({
    contentContainer: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        alignItems: 'stretch'
    },
    listContainer: {
        width: '50%', display: 'flex', background: '#f7f7f7'
    }
}))

const SelectTemplatesModal = (props) => {
    const classes = useStyles();
    const {isOpen, onClose, selectTemplate} = props;
    const [selectedFilter, setSelectedFilter] = useState();
    const [textFilter, setTextFilter] = useState();
    const [selectedTemplate, setSelectedTemplate] = useState();

    async function onSelectTemplate(id) {
        setSelectedTemplate(id)
    }

    async function useTemplate() {
        if (!selectedTemplate) {
            onClose();
            return;
        }
        const template = await request({
            url: "/screen/read",
            data: {id: selectedTemplate}
        })
        selectTemplate(template)
        onClose()
    }

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth={"lg"} fullWidth={true} scroll={'paper'}>
            <DialogTitle style={{padding: '10px 15px'}}>
                <Typography>New Screen</Typography>
            </DialogTitle>
            <DialogContent style={{padding: 0}} dividers>
                <div className={classes.contentContainer}>
                    <div className={classes.listContainer}>
                        <CategoryList
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}
                            setTextFilter={setTextFilter}
                        />
                        <TemplatesGrid isOpen={isOpen} onSelectTemplate={onSelectTemplate}
                                       selectedFilter={selectedFilter}
                                       textFilter={textFilter}
                        />
                    </div>
                    <div style={{width: '50%'}}>
                        <CreateFromTemplate
                            selectedTemplate={selectedTemplate}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant={'contained'} color={'primary'} size={'small'}
                        onClick={useTemplate}
                >
                    Use Template
                </Button>
            </DialogActions>
        </Dialog>
    )

}

export default SelectTemplatesModal

SelectTemplatesModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    selectTemplate: PropTypes.func
}